// Duck for ReportIssuePage (renter-side pickup issue, v2 process).
import { storableError } from '../../util/errors';
import { postHandoffTransition } from '../../util/pickupCode';
import { pickReportIssueTransition } from './transitionDispatch';

const FETCH_TX_REQUEST = 'app/ReportIssuePage/FETCH_TX_REQUEST';
const FETCH_TX_SUCCESS = 'app/ReportIssuePage/FETCH_TX_SUCCESS';
const FETCH_TX_ERROR = 'app/ReportIssuePage/FETCH_TX_ERROR';
const SUBMIT_REQUEST = 'app/ReportIssuePage/SUBMIT_REQUEST';
const SUBMIT_SUCCESS = 'app/ReportIssuePage/SUBMIT_SUCCESS';
const SUBMIT_ERROR = 'app/ReportIssuePage/SUBMIT_ERROR';
const SUBMIT_RESET = 'app/ReportIssuePage/SUBMIT_RESET';

const initialState = {
  transaction: null,
  fetchInProgress: false,
  fetchError: null,
  submitInProgress: false,
  submitError: null,
  submitSuccess: false,
  // 'continue' (rental started with issue) or 'cancel' (refund request,
  // held for operator review). Lets the success screen show the right copy.
  submitAction: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TX_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_TX_SUCCESS:
      return { ...state, fetchInProgress: false, transaction: action.payload };
    case FETCH_TX_ERROR:
      return { ...state, fetchInProgress: false, fetchError: action.payload };
    case SUBMIT_REQUEST:
      return {
        ...state,
        submitInProgress: true,
        submitError: null,
        submitSuccess: false,
        submitAction: action.payload,
      };
    case SUBMIT_SUCCESS:
      return { ...state, submitInProgress: false, submitSuccess: true };
    case SUBMIT_ERROR:
      return { ...state, submitInProgress: false, submitError: action.payload };
    case SUBMIT_RESET:
      return { ...state, submitError: null, submitSuccess: false, submitAction: null };
    default:
      return state;
  }
}

export const submitReset = () => ({ type: SUBMIT_RESET });

export const loadData = params => (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_TX_REQUEST });
  return sdk.transactions
    .show({ id: params.id, include: ['customer', 'provider', 'listing', 'booking'] })
    .then(resp => {
      const tx = resp?.data?.data;
      const included = resp?.data?.included || [];
      const byRel = rel => included.find(e => e.id.uuid === rel?.id?.uuid);
      dispatch({
        type: FETCH_TX_SUCCESS,
        payload: {
          ...tx,
          customer: byRel(tx?.relationships?.customer?.data),
          provider: byRel(tx?.relationships?.provider?.data),
          listing: byRel(tx?.relationships?.listing?.data),
          booking: byRel(tx?.relationships?.booking?.data),
        },
      });
    })
    .catch(e => {
      dispatch({ type: FETCH_TX_ERROR, payload: storableError(e) });
      throw e;
    });
};

/**
 * Submit a pickup-issue report.
 *
 * @param {object} args
 * @param {string} args.transactionId
 * @param {string} args.processState  current state (accepted | kit-ready)
 * @param {string} args.action         'continue' | 'cancel'
 * @param {string} args.description
 * @param {string[]} args.photoKeys
 */
export const submitReportIssue = ({
  transactionId,
  processState,
  action,
  description,
  photoKeys,
}) => dispatch => {
  const transition = pickReportIssueTransition(processState, action);
  if (!transition) {
    const err = new Error(
      `Invalid pickup-issue submission: state=${processState}, action=${action}`
    );
    err.code = 'INVALID_TRANSITION';
    dispatch({ type: SUBMIT_ERROR, payload: storableError(err) });
    return Promise.reject(err);
  }

  dispatch({ type: SUBMIT_REQUEST, payload: action });

  return postHandoffTransition({
    transactionId,
    transition,
    orderData: {
      pickupIssueAt: new Date().toISOString(),
      pickupIssueDescription: description,
      pickupIssuePhotos: photoKeys || [],
    },
  })
    .then(r => {
      dispatch({ type: SUBMIT_SUCCESS });
      return r;
    })
    .catch(err => {
      dispatch({ type: SUBMIT_ERROR, payload: storableError(err) });
      throw err;
    });
};
